import { PlanType } from 'enums';
import { RootStore, withInjectedRootStore } from 'providers';
import * as React from 'react';
import { EnterpriseModalClickSource } from 'services/BiLogger/BiLoggerTypes';

interface EnterpriseRefContextActions {
  scrollToRef(clickSource?: EnterpriseModalClickSource): void;
  setRef(ref: React.RefObject<HTMLElement>): void;
  shouldShowSuccsessMessage: boolean;
  showSuccsessMessage: React.Dispatch<React.SetStateAction<boolean>>;
}
export const EnterpriseRefContext =
  React.createContext<EnterpriseRefContextActions>({} as any);

export const useEnterpriseRefContext = () =>
  React.useContext(EnterpriseRefContext);

interface EnterpriseTabContextProviderCompProps {
  rootStore: RootStore;
}
const EnterpriseTabContextProviderComp: React.FC<
  EnterpriseTabContextProviderCompProps
> = ({ children, rootStore }) => {
  const [ref, setRef] = React.useState<React.RefObject<HTMLElement>>(
    null as any,
  );
  const [shouldShowSuccsessMessage, showSuccsessMessage] =
    React.useState(false);

  const scrollToRef = (clickSource?: EnterpriseModalClickSource) => {
    ref?.current?.scrollIntoView({ behavior: 'smooth' });
    showSuccsessMessage(false);
    const {
      appContext: { biLogger },
    } = rootStore!.appStore;
    biLogger.logRequestCallPopupLoad({
      ppType: PlanType.Enterprise,
      clickType: clickSource,
    });
  };

  return (
    <EnterpriseRefContext.Provider
      value={{
        scrollToRef,
        setRef,
        shouldShowSuccsessMessage,
        showSuccsessMessage,
      }}
    >
      {children}
    </EnterpriseRefContext.Provider>
  );
};

export const EnterpriseTabContextProvider = withInjectedRootStore(
  EnterpriseTabContextProviderComp,
);
